import { initializeApp } from "firebase/app";

export const firebaseConfig = {
  apiKey: "AIzaSyBappFiMwUqZsejglvwQwMfzZSVASqZo3A",
  authDomain: "kokolk-web.firebaseapp.com",
  projectId: "kokolk-web",
  storageBucket: "kokolk-web.appspot.com",
  messagingSenderId: "306075494198",
  appId: "1:306075494198:web:5124be6c8e1a40e4f17597",
  measurementId: "G-7W8BHWH9EC",
};


const firebaseApp = initializeApp(firebaseConfig);
export { firebaseApp };